import React from 'react';
import QuoteStepLayout from "../QuoteStepLayout";
import QuickProgress from '../../components/QuickProgress';

interface IProps {
    id: string,
    children : any,
    className?: string;
}

export const QuickQuoteStep = (props: IProps) => {
    return (
        <QuoteStepLayout id={props.id} children={props.children} className={props.className} progress={<QuickProgress />} />
    );
}